import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  getCustomUser,
  updateUser,
  getCustomAdmin,
} from "../api";
import "../styles/sifaris.css";

const ONE_SIGNAL_APP_ID = "26a128f2-4ccf-4dde-9986-2b27bb1a25b2";
const ONE_SIGNAL_REST_API_KEY =
  "os_v2_app_e2qsr4smz5g55gmgfmt3wgrfwlr3fpv76kau37n2xxvu2m2krc6g3wi4dhudjinuajtqdxnsbt5rlnnumq6osxxaalhxyhmzkypia5q";

const AppModal = ({
  open,
  title = "Diqqət",
  message = "",
  type = "info",
  buttonText = "Bağla",
  onClose,
  actions,
}) => {
  if (!open) return null;

  return (
    <div className="sq-modal-overlay">
      <div className="sq-alert-modal">
        <h3 className={`sq-alert-title sq-alert-${type}`}>{title}</h3>
        <p className="sq-alert-message">{message}</p>

        {actions?.length ? (
          <div className="sq-alert-actions">
            {actions.map((action, index) => (
              <button
                key={index}
                type="button"
                className={`sq-alert-button ${
                  action.variant === "secondary"
                    ? "sq-alert-button-secondary"
                    : ""
                }`}
                onClick={action.onClick}
              >
                {action.label}
              </button>
            ))}
          </div>
        ) : (
          <button type="button" className="sq-alert-button" onClick={onClose}>
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

const WaitingRoomScreen = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [userLocalData, setUserLocalData] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const [selfie, setSelfie] = useState(null);
  const [idFront, setIdFront] = useState(null);
  const [idBack, setIdBack] = useState(null);

  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "info",
    buttonText: "Bağla",
    actions: null,
  });

  const showModal = ({
    title = "Diqqət",
    message = "",
    type = "info",
    buttonText = "Bağla",
    actions = null,
  }) => {
    setModalConfig({ title, message, type, buttonText, actions });
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const userType = useMemo(
    () => String(userLocalData?.userType || ""),
    [userLocalData]
  );

  useEffect(() => {
    let intervalId;

    const fetchUserData = async () => {
      try {
        const userId = localStorage.getItem("id");
        const storedPassword = localStorage.getItem("password");

        if (!userId) {
          navigate("/sifaris/login", { replace: true });
          return;
        }

        const userData = await getCustomUser(userId);

        if (!userData?.data) {
          showModal({
            title: "Xəta",
            message: "İstifadəçi məlumatları tapılmadı.",
            type: "error",
          });
          return;
        }

        const data = userData.data;
        const currentUserType = String(data.userType || "");

        if (data.isDisable) {
          showModal({
            title: "Diqqət!",
            message: "Hesabınız Admin tərəfindən bloklanmışdır!",
            type: "error",
            actions: [
              {
                label: "Girişə qayıt",
                onClick: () => {
                  closeModal();
                  localStorage.clear();
                  navigate("/sifaris/login", { replace: true });
                },
              },
            ],
          });
          return;
        }

        if (storedPassword && data.password !== storedPassword) {
          showModal({
            title: "Diqqət!",
            message: "Şifrəniz dəyişdirilib. Yenidən daxil olun!",
            type: "warning",
            actions: [
              {
                label: "Girişə qayıt",
                onClick: () => {
                  closeModal();
                  localStorage.clear();
                  navigate("/sifaris/login", { replace: true });
                },
              },
            ],
          });
          return;
        }

        setUserLocalData(data);
        setLoading(false);

        if (
          currentUserType.includes("courier") &&
          (!data.identifyPhoto || data.identifyPhoto.length === 0) &&
          data.courierStatus !== "accept" &&
          data.courierStatus !== "decline"
        ) {
          setModalVisible(true);
        } else {
          setModalVisible(false);
        }

        if (currentUserType.includes("courier") && data.courierStatus === "accept") {
          localStorage.removeItem("waitingRoom");
          navigate("/sifaris/order-group", { replace: true });
          return;
        }

        if (currentUserType.includes("customer")) {
          localStorage.removeItem("waitingRoom");
          navigate("/sifaris/order-group", { replace: true });
        }
      } catch (error) {
        console.error("İstifadəçi məlumatlarını alarkən xəta:", error);
        showModal({
          title: "Xəta",
          message: "Məlumatları yükləmək alınmadı.",
          type: "error",
        });
      }
    };

    fetchUserData();
    intervalId = setInterval(fetchUserData, 5000);

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [navigate]);

  const handleLogout = async () => {
    localStorage.clear();
    navigate("/sifaris/login", { replace: true });
  };

  const handleSelectImage = (event, setter) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setter(file);
  };

  const convertFileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      if (!file) {
        resolve("");
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = String(reader.result || "");
        const base64 = result.includes(",") ? result.split(",")[1] : result;
        resolve(base64);
      };
      reader.onerror = reject;
    });

  const uploadImage = async (base64Image) => {
    const apiKeys = [
      "4b8d7989751c89d9561fd1e44100bf68",
      "2c5257b8de4e5bf05fc5a7b2419a418e",
      "62346dd09fb59412e2774c150742d3a4",
    ];

    const tryUpload = async (apiKey) => {
      const formData = new FormData();
      formData.append("key", apiKey);
      formData.append("image", base64Image);

      const response = await axios.post(
        "https://api.imgbb.com/1/upload",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      return response.data.data.url;
    };

    for (let i = 0; i < apiKeys.length; i += 1) {
      try {
        const url = await tryUpload(apiKeys[i]);
        return url;
      } catch (err) {
        if (i === apiKeys.length - 1) {
          throw new Error("Şəkil yüklənərkən xəta baş verdi.");
        }
      }
    }

    throw new Error("Şəkil yüklənərkən xəta baş verdi.");
  };

  const sendPushNotification = async (
    pushSubscriptionIds,
    messageTitle,
    messageBody
  ) => {
    try {
      await axios.post(
        "https://onesignal.com/api/v1/notifications",
        {
          app_id: ONE_SIGNAL_APP_ID,
          include_subscription_ids: Array.isArray(pushSubscriptionIds)
            ? pushSubscriptionIds
            : [pushSubscriptionIds],
          channel_for_external_user_ids: "push",
          headings: { en: messageTitle },
          contents: { en: messageBody },
          android_channel_id: "66708726-e8b4-4b02-b8db-4c8343046b23",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${ONE_SIGNAL_REST_API_KEY}`,
          },
        }
      );
    } catch (error) {
      console.error(
        "Push bildirimi gönderme hatası:",
        error.response?.data || error.message
      );
    }
  };

  const handleSubmitDocuments = async () => {
    try {
      setLoadingOverlayVisible(true);

      const userId = localStorage.getItem("id");
      const storedUserType = localStorage.getItem("userType") || "";

      let updatedData = {};

      if (!storedUserType.includes("customer")) {
        if (!selfie || !idFront || !idBack) {
          showModal({
            title: "Xəta!",
            message: "Zəhmət olmasa bütün sənədləri yükləyin.",
            type: "error",
          });
          setLoadingOverlayVisible(false);
          return;
        }

        const selfieUrl = await uploadImage(await convertFileToBase64(selfie));
        const idFrontUrl = await uploadImage(await convertFileToBase64(idFront));
        const idBackUrl = await uploadImage(await convertFileToBase64(idBack));

        updatedData.identifyPhoto = [selfieUrl, idFrontUrl, idBackUrl];
      }

      if (storedUserType.includes("courier")) {
        updatedData.courierStatus = "active";
      }

      await updateUser(userId, updatedData);

      try {
        const adminId = "1";
        const adminData = await getCustomAdmin(adminId);
        const adminOneSignalId = adminData?.data?.oneSignal;

        if (adminOneSignalId) {
          await sendPushNotification(
            adminOneSignalId,
            "🛵 Yeni Kuryer İstəyi",
            "Kuryer qeydiyyat üçün sənədlərini sorğu üçün sizə göndərdi."
          );
        }
      } catch {}

      setModalVisible(false);
      setLoadingOverlayVisible(false);

      showModal({
        title: "Təşəkkürlər!",
        message:
          "Sənədləriniz və sorğumuz uğurla göndərildi. Ana səhifəyə yönləndirilirsiniz.",
        type: "success",
        actions: [
          {
            label: "Ana səhifəyə qayıt",
            onClick: () => {
              closeModal();
              navigate("/sifaris/order-group", { replace: true });
            },
          },
        ],
      });
    } catch (error) {
      console.error("Sənədlər göndərilərkən xəta:", error);
      showModal({
        title: "Xəta!",
        message: "Sənədləri göndərərkən problem yarandı.",
        type: "error",
      });
    } finally {
      setLoadingOverlayVisible(false);
    }
  };

  const openWhatsApp = () => {
    const phoneNumber = "994709559984";
    const message =
      "Salam, sorğumla bağlı məlumat almaq istəyirəm.\n" +
      `Ad, Soyad: ${userLocalData?.name || ""}\n` +
      `Telefon nömrəsi: ${userLocalData?.phoneNumber || ""}`;

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      <div className="sq-waiting-container">
        
        {loading ? (
          <div className="sq-waiting-loader-wrap">
            <div className="sq-spinner" />
          </div>
        ) : (
          <>
            {userType.includes("courier") &&
              userLocalData?.courierStatus === "active" && (
                <div className="sq-waiting-alert-box">
                  <div className="sq-waiting-alert-text">
                    ✅ Sorğunuz göndərilib. Zəhmət olmasa adminlə görüntülü əlaqə
                    saxlayın.
                  </div>

                  <button
                    type="button"
                    className="sq-waiting-whatsapp-btn"
                    onClick={openWhatsApp}
                  >
                    📲 WhatsApp ilə əlaqə
                  </button>
                </div>
              )}

            {userType.includes("courier") &&
              userLocalData?.courierStatus === "decline" && (
                <div className="sq-waiting-alert-box">
                  <div className="sq-waiting-error-text">
                    ❌ Təəssüf ki, təsdiqiniz rədd edilib. Zəhmət olmasa yenidən
                    müraciət etmək üçün əlaqə saxlayın.
                  </div>

                  <button
                    type="button"
                    className="sq-waiting-whatsapp-btn"
                    onClick={openWhatsApp}
                  >
                    📲 WhatsApp ilə əlaqə
                  </button>
                </div>
              )}

            <button
              type="button"
              className="sq-waiting-close-btn"
              onClick={handleLogout}
            >
              Çıxış Et
            </button>
          </>
        )}

        {loadingOverlayVisible && (
          <div className="sq-fullscreen-overlay">
            <div className="sq-spinner sq-spinner-light" />
            <div className="sq-loading-text">Sənədlər göndərilir...</div>
          </div>
        )}

        {userType !== "customer" && modalVisible && (
          <div className="sq-modal-overlay">
            <div className="sq-waiting-card">
              <div className="sq-waiting-card-header">
                <div className="sq-waiting-card-title">Sənədlərin təsdiqi</div>

                <button
                  type="button"
                  className="sq-waiting-card-close"
                  onClick={() => setModalVisible(false)}
                >
                  ✕
                </button>
              </div>

              <div className="sq-waiting-card-scroll">
                <div className="sq-waiting-card-hint">
                  Qısa addımlarla təsdiqlə və dərhal istifadəyə başla.
                </div>

                <div className="sq-waiting-block">
                  <div className="sq-waiting-block-title">1. Selfie</div>

                  <label className="sq-waiting-primary-btn">
                    <span>📸 Şəkil seç</span>
                    <input
                      type="file"
                      accept="image/*"
                      capture="user"
                      hidden
                      onChange={(e) => handleSelectImage(e, setSelfie)}
                    />
                  </label>

                  {selfie && (
                    <img
                      src={URL.createObjectURL(selfie)}
                      alt="Selfie"
                      className="sq-waiting-thumb"
                    />
                  )}
                </div>

                <div className="sq-waiting-block">
                  <div className="sq-waiting-block-title">
                    2. Şəxsiyyət Vəsiqəsi (ön)
                  </div>

                  <label className="sq-waiting-secondary-btn">
                    <span>Şəkil seç</span>
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={(e) => handleSelectImage(e, setIdFront)}
                    />
                  </label>

                  {idFront && (
                    <img
                      src={URL.createObjectURL(idFront)}
                      alt="ID Front"
                      className="sq-waiting-thumb"
                    />
                  )}
                </div>

                <div className="sq-waiting-block">
                  <div className="sq-waiting-block-title">
                    3. Şəxsiyyət Vəsiqəsi (arxa)
                  </div>

                  <label className="sq-waiting-secondary-btn">
                    <span>Şəkil seç</span>
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={(e) => handleSelectImage(e, setIdBack)}
                    />
                  </label>

                  {idBack && (
                    <img
                      src={URL.createObjectURL(idBack)}
                      alt="ID Back"
                      className="sq-waiting-thumb"
                    />
                  )}
                </div>

                <button
                  type="button"
                  className={`sq-waiting-submit-btn ${
                    loading || loadingOverlayVisible ? "sq-disabled-btn" : ""
                  }`}
                  disabled={loading || loadingOverlayVisible}
                  onClick={handleSubmitDocuments}
                >
                  {loading || loadingOverlayVisible
                    ? "Gözləyin..."
                    : "Sənədləri göndər"}
                </button>

                <div className="sq-waiting-note">
                  Göndərdikdən sonra ana ekrana qayıdacaqsınız. Təsdiq olunduqda
                  sifariş qrupuna giriş aktivləşəcək.
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <AppModal
        open={modalOpen}
        title={modalConfig.title}
        message={modalConfig.message}
        type={modalConfig.type}
        buttonText={modalConfig.buttonText}
        actions={modalConfig.actions}
        onClose={closeModal}
      />
    </>
  );
};

export default WaitingRoomScreen;